import { render, staticRenderFns } from "./ObjectsTreePlace.vue?vue&type=template&id=47c47298"
import script from "./ObjectsTreePlace.vue?vue&type=script&lang=ts"
export * from "./ObjectsTreePlace.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports